import React, { useState, useEffect } from 'react';
import ReactDOM from 'react-dom'
import DashboardHeader from '../../shared/components/DashboardHeader';
import SideMenu from '../../shared/components/SideMenu';
import Footer from '../../shared/components/Footer';

import HttpCall from '../../api/Http';
import SerializeClass from '../../shared/Utils/serialized';
import User from '../../shared/Utils/User';
import axios from 'axios';
import swal from 'sweetalert';
import Alert from '../../shared/Utils/AlertBox';
import Loader from '../../shared/components/Loader';
import { useLocation } from "react-router-dom";
import { useSearchParams } from "react-router-dom";

export default function SequenceReport(props) {

    const {state} = useLocation();
    const { lead_list_name, lead_list_id, sequence_name, sequence_id } = state ? state : 0;
    const [loader, setLoader] = useState(false);
    const [sequenceID, setsequenceID] = useState(sequence_id);
    const [leadID, setleadID] = useState(lead_list_id);
    const [sequenceName, setsequenceName] = useState(sequence_name);
    const [leadName, setleadName] = useState(lead_list_name);
    const [agentSequenceList, setAgentSequenceList] = useState([])
    const [searchParams, setSearchParams] = useSearchParams();



    const [inputValue, setInputValue] = useState({ 
      agentName: "",
      message_sent: "", 
      replied:"",
      sending_failed:"",
      not_complaint: "",
      remaining: "",
      delivered:"",
      opened:"",
      searchText:""
     });

    const { agentName,
            message_sent, 
            replied,
            sending_failed,
            not_complaint,
            remaining,
            delivered,
            opened,
            searchText
          } = inputValue;

    const user = User.getUser()

    const handleChange = (e) => {
        var { name, value } = e.target;
        if(name=='message_sent' || name=='replied' || name=='sending_failed' || name=='not_complaint' 
            || name=='remaining' || name=='delivered' || name=='opened') {
            value = value.replace(/[^0-9]/gi, '');
        }
        setInputValue((prev) => ({...prev,[name]: value,}));
    };


    useEffect(() => {
      getAgentSequenceList();
      }, [])
  
    const getAgentSequenceList = () => {
      let arr = [];
      // arr.push({P_user_id: user[0].Id});
      arr.push({P_Search_Text: searchText});
      arr.push({P_Sequence_id: searchParams.get("sequence_id")});
      let p = SerializeClass.getSerializedData(arr);
      let header = {
        headers: {'Authorization': `Token ${user[0].token}`}
      };
      let url = `https://api.getbound.ai/api/user/getDailySequenceStats?Params=${p}`;
        axios.get(url,header).then(response => {
            if(response.data.code==200) {
            setAgentSequenceList(response.data.data);
            } else {
                Alert.show( "Error!", response.data.msg, "error");
            }
        }).catch(err => {
          console.log(err);
        })
    }


    function addAccount(e) {
        
        e.preventDefault();
        if(!sequenceID) return Alert.show('Error','Please select the sequence','error')
        let url = `/api/agent/addSequenceStats`;

        if(!agentName || !message_sent || !replied || !sending_failed || !not_complaint 
              || !remaining || !delivered || !opened) {
          return Alert.show('Error!','Please enter the required field','error')
        }

        let requestData = new FormData();
        let arr = [];
        arr.push({P_sequence_id: sequenceID});
        arr.push({P_lead_list_id: leadID});
        arr.push({P_entry_date: new Date()});
        arr.push({P_agent_name: agentName});
        arr.push({P_message_sent: message_sent});
        arr.push({P_replied: replied});
        arr.push({P_sending_failed: sending_failed});
        arr.push({P_not_complaint: not_complaint});
        arr.push({P_remaining: remaining});
        arr.push({P_delivered: delivered});
        arr.push({P_opened: opened});
        arr.push({P_created_by: user[0].Id});

        let p = SerializeClass.getSerializedData(arr);
        requestData.append('Params', p);
        setLoader(true);
        HttpCall.postRequest2(url,requestData).then(response => {
            setLoader(false);
            if(response.data.code==200) {
                Alert.show( "Success!","Record Added Successfully.", "success");
                //setInputValue(() => ({name: '', email: '', website: ''}))
                setTimeout(() => { window.location.reload(false); },100) 
                
            } else {
                swal({
                    title: "Error!",
                    text: response.data.msg,
                    icon: "error",
                    button: "Ok",
                })
            }
        }).catch(err => {
            console.log(err);
        })
    }

    function searchRecord(e) {
      e.preventDefault();
      getAgentSequenceList();

    }

    return(

        <>
    <DashboardHeader />
    <div className="container-fluid page-body-wrapper">
      
      <SideMenu />
      {loader && <Loader />}
      <div className="main-panel">
        <div className="content-wrapper">
          <div className="row">
            
          <div class="col-md-12 grid-margin stretch-card">
              <div class="card">
                <div class="card-body">
                  <h2 class="card-title">Sequence Progress Report</h2>
                  <h4 class="card-title">
                    Sequence Name : <a href='#'>Holiday Boost - All Title</a>
                  </h4>
                  <a type="button" href="/dashboard" class="btn btn-info btn-sm marginright10 absolutbtn">Back</a>

                  <div class="home-tab">
                    <div class="tab-content tab-content-basic">
                      <div class="tab-pane fade show active" id="overview" role="tabpanel" aria-labelledby="overview"> 
                        <div class="row">
                          <div class="col-sm-12">
                            <div class="statistics-details d-flex align-items-center justify-content-between">
                              <div>
                                <p class="statistics-title">Lead List</p>
                                <h3 class="rate-percentage">134</h3>
                                <p class="text-danger d-flex"><i class="mdi mdi-menu-down"></i><span>-0.5%</span></p>
                              </div>
                              <div>
                                <p class="statistics-title">Sent / Call</p>
                                <h3 class="rate-percentage">168</h3>
                                <p class="text-success d-flex"><i class="mdi mdi-menu-up"></i><span>+0.1%</span></p>
                              </div>
                              <div>
                                <p class="statistics-title">Not Compliant</p>
                                <h3 class="rate-percentage">68</h3>
                                <p class="text-danger d-flex"><i class="mdi mdi-menu-down"></i><span>68.8</span></p>
                              </div>
                              <div class="d-none d-md-block">
                                <p class="statistics-title">Replied / Answered </p>
                                <h3 class="rate-percentage">18</h3>
                                <p class="text-success d-flex"><i class="mdi mdi-menu-down"></i><span>+0.8%</span></p>
                              </div>
                              <div class="d-none d-md-block">
                                <p class="statistics-title">Opportunity</p>
                                <h3 class="rate-percentage">06</h3>
                                <p class="text-danger d-flex"><i class="mdi mdi-menu-down"></i><span>68.8</span></p>
                              </div>
                              <div class="d-none d-md-block">
                                <p class="statistics-title">Deal Closed</p>
                                <h3 class="rate-percentage">05</h3>
                                <p class="text-success d-flex"><i class="mdi mdi-menu-down"></i><span>+0.8%</span></p>
                              </div>
                            </div>
                          </div>
                        </div> 
                      </div>
                    </div>
                
                    <div class="row">
                      
                      <div class="col-lg-8 d-flex flex-column">
                        <div class="row flex-grow">
                          <div class="col-12 col-lg-4 col-lg-12 grid-margin stretch-card">
                            <div class="card card-rounded">
                              <div class="card-body">
                                <div class="d-sm-flex justify-content-between align-items-start">
                                  <div>
                                   <h4 class="card-title card-title-dash">Sequence Activities Performance</h4>
                                   </div>
                                  <div id="performance-line-legend"></div>
                                </div>
                                <div class="chartjs-wrapper mt-5">
                                  <canvas id="performaneLine"></canvas>
                                </div>
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                      <div class="col-lg-4 d-flex flex-column">
                        <div class="row">
                          <div class="col-lg-12">
                            <div class="d-flex justify-content-between align-items-center mb-3">
                              <h4 class="card-title card-title-dash">Overall Activity Results</h4>
                            </div>
                            <canvas class="my-auto" id="doughnutChart" height="200"></canvas>
                            <div id="doughnut-chart-legend" class="mt-5 text-center"></div>
                          </div>
                        </div>
                      </div>
                      <div class="col-lg-4 d-flex flex-column"> 
                        <div class="row">
                          <div class="col-lg-12">
                            <div class="d-flex justify-content-between align-items-center mb-3">
                              <h4 class="card-title card-title-dash">Day 01</h4>
                            </div>
                            <canvas class="my-auto" id="doughnutChart02" height="200"></canvas>
                            <div id="doughnut-chart-legend02" class="mt-5 text-center"></div>
                          </div>
                        </div>
                      </div>
                      <div class="col-lg-4 d-flex flex-column"> 
                        <div class="row">
                          <div class="col-lg-12">
                            <div class="d-flex justify-content-between align-items-center mb-3">
                              <h4 class="card-title card-title-dash">Day 02</h4>
                            </div>
                            <canvas class="my-auto" id="doughnutChart03" height="200"></canvas>
                            <div id="doughnut-chart-legend03" class="mt-5 text-center"></div>
                          </div>
                        </div>
                      </div>
                      <div class="col-lg-4 d-flex flex-column"> 
                        <div class="row">
                          <div class="col-lg-12">
                            <div class="d-flex justify-content-between align-items-center mb-3">
                              <h4 class="card-title card-title-dash">Day 03</h4>
                            </div>
                            <canvas class="my-auto" id="doughnutChart04" height="200"></canvas>
                            <div id="doughnut-chart-legend04" class="mt-5 text-center"></div>
                          </div>
                        </div>
                      </div>

                    </div>


                    <div class="row flex-grow">
                          <div class="col-12 grid-margin stretch-card">
                            <div class="card card-rounded">
                              <div class="card-body">
                                
                              </div>
                            </div>
                          </div>
                        </div>

                  </div>
                  
                </div>
              </div>
            </div>



            <div class="col-lg-12 grid-margin stretch-card">
              <div class="card">
                
                <div class="card-body">
                  <h4 class="card-title">Sequence Progress Report</h4>
                    <div className="row">
                        <div className="col-md-6">
                            <div className="form-group">
                            <input type="text" className="form-control form-control-lg" 
                            onChange={handleChange} value={searchText} name="searchText" placeholder='Search '/>
                            </div>
                        </div>
                        <div className="col-md-3">
                        <div className="form-group">
                            <button type="submit" className="btn btn-primary me-2 savebtn" onClick={searchRecord}>
                                Search
                            </button>
                            </div>
                        </div>
                    </div>
                  
                  <div class="table-responsive">
                    <table class="table">
                      <thead>
                        <tr>
                          <th>#</th>
                          <th>Sequence Name</th>
                          <th>Status</th>
                          <th>Lead List Name</th>
                          <th>Lead Records</th>
                          <th>Message/Email Sent</th>
                          <th>Customer Replies</th>
                          <th>Data Not Compliant</th>
                        </tr>
                      </thead>
                      <tbody>
                      { agentSequenceList.length> 0 && agentSequenceList.map( (data, index) => (<tr key={index}>
                          <td>{index+1}</td>
                          <td>{data.sequence_name}</td>
                          <td><label>{data.status_name}</label></td>
                          <td>{data.lead_list_name}</td>
                          <td>{data.lead_list_records}</td>
                          <td>{data.message_sent}</td>
                          <td>{data.replied}</td>
                          <td>{data.not_complaint}</td>
                        </tr> ))}
                      </tbody>
                    </table>
                  </div>
                </div>
              </div>
            </div>
        </div>
        </div>
        
        <Footer />
      </div>
      </div>
      </>

    )
}